<div class="container-fluid pb-5">
    <div class="d-flex align-items-center justify-content-between mb-2">
        <h4 class="main-heading">Fax Prescription Detail - {{ details?.document_type_name
              ? helperService.stringConvertToTitleCase(details?.document_type_name) : 'N/A'}}</h4>
        <button class="btn" mat-icon-button (click)="dialogRef.close()" type="button">
            <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
        </button>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card shadow-sm">
                <div class="card-body">
                    <div class="row">
                        <!-- Patient Info -->
                        <div class="col-md-4 mb-3">
                            <h5 class="mb-3">Patient Info</h5>
                            <div><strong>ID:</strong> {{ details?.id || 'N/A' }}</div>
                            <div><strong>Name:</strong> {{ details?.name || 'N/A' }}</div>
                            <div><strong>DOB:</strong> {{ details?.dob || 'N/A' }}</div>
                            <div><strong>Gender:</strong> {{ details?.gender || 'N/A' }}</div>
                            <div><strong>Repeats:</strong> {{ details?.is_repeats || 'N/A' }}</div>
                            <div><strong>Allergy:</strong> {{ details?.allergy || 'N/A' }}</div>
                            <div><strong>Health Card:</strong> {{ details?.health_card || 'N/A' }}</div>
                            <div><strong>Phone:</strong> {{ details?.phone || 'N/A' }}</div>
                            <div><strong>Address:</strong> {{ details?.address || 'N/A' }}</div>
                            <div><strong>Instructions:</strong> {{ details?.instructions || 'N/A' }}</div>
                            <div><strong>Prescription Date:</strong> {{ details?.prescription_date || 'N/A' }}</div>
                        </div>

                        <!-- Doctor Info -->
                        <div class="col-md-4 mb-3">
                            <h5 class="mb-3">Doctor Info</h5>
                            <div><strong>Name:</strong> {{ details?.doctor_info?.name || 'N/A' }}</div>
                            <div><strong>Phone:</strong> {{ details?.doctor_info?.phone || 'N/A' }}</div>
                            <div><strong>Fax:</strong> {{ details?.doctor_info?.fax || 'N/A' }}</div>
                            <div><strong>License:</strong> {{ details?.doctor_info?.license || 'N/A' }}</div>
                            <div><strong>CPSO:</strong> {{ details?.doctor_info?.cpso || 'N/A' }}</div>
                            <div><strong>Type:</strong> {{ details?.doctor_info?.type || 'N/A' }}</div>
                            <div><strong>Address:</strong> {{ details?.doctor_info?.address || 'N/A' }}</div>
                        </div>
                        <div class="col-md-4 text-center">
                            <button class="btn btn-primary btn-sm download-link" matTooltipPosition="above"
                                matTooltip="Download Original PDF" (click)="openPdf(details)"> <span>View</span>
                                <mat-icon>picture_as_pdf</mat-icon></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noImg>
        <div class="no-img-placeholder">
            <img src="../../../assets/images/no-image-found.png" alt="Image not found" class="image-placeholder" />
        </div>
    </ng-template>


    <div class="d-flex align-items-center justify-content-between mt-2">
        <h4 class="main-heading">Drug List Detail</h4>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card shadow-sm">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="acute">
                                <div class="acute-content">
                                    <ng-template #noChronicData>
                                        <div
                                            class="d-flex flex-column align-items-center w-100 justify-content-center noAcuteDataFound">
                                            <img src="assets/images/emptystate.png" alt="no data found icon"
                                                class="mb-3" />
                                            <div class="bold">No Data Found</div>
                                        </div>
                                    </ng-template>

                                    <div class="acuteDataFound">

                                        <div class="pagination-table">
                                            <table class="table table-striped p-dash" aria-describedby="Users table">
                                                <thead>
                                                    <tr>
                                                        <th class="d-none"></th>
                                                        <th>Rx Num</th>
                                                        <th>Drug Name</th>
                                                        <th>Dosage</th>
                                                        <th>Repeats</th>
                                                        <th>Quantity</th>
                                                        <th>Strength</th>
                                                        <th>Dosage Form</th>
                                                        <th>Instructions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of DrugList">
                                                        <td>{{ item?.rxNum || '-'}}</td>
                                                        <td>{{ item?.drugName || '-'}}</td>
                                                        <td>{{ item?.dosage || '-'}}</td>
                                                        <td>{{ item?.repeats || '-'}}</td>
                                                        <td>{{ item?.quantity || '-'}}</td>
                                                        <td>{{ item?.strength || '-'}}</td>
                                                        <td>{{ item?.dosageForm || '-'}}</td>
                                                        <td>{{ item?.instructions || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
